import styled from "styled-components";
import loginLogo from "../../../images/login-logo.svg";
import guestLogo from "../../../images/guest-logo.svg";
import nextLogo from "../../../images/next-logo.png";
import helpLogo from "../../../images/get-help-icon.png";
import anotherChildicon from "../../../images/sponsor_another_child.svg";
import referIcon from "../../../images/referIcon.svg";
import visitWebSiteicon from "../../../images/wv_visit_website_click.svg";

const Button = styled.button`
width: 100%;
height: 50px;
border-radius: 8px;
border:none;
`
export const LoginButton = styled(Button)`
//width: 90%;
width: 304px;
margin:0 auto;
margin-bottom: 13px;
background: #F66700;
box-shadow: 0px 3px 0px #C75300;
& span{
    //font-style: normal;
    font-family: 'Lato-Bold';
    font-size: 18px;
    line-height: 120%;
    display: inline-flex;
    align-self:center;
    letter-spacing: 0.01em;
    color: #FFFFFF;
    position:relative;
    left: -10px;
}
& span:after{
    background: url(${loginLogo}) 0 0;
    content:" ";
    width:16px;
    height:16px;
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    right:-25px;
}
@media screen and (max-width: 850px){
    &{
        margin-left:auto;
        margin-top: 10px;
        // width: 350px;  // removed for mobile screens
    }
} 
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation:portrait) {
    width: 70%;
}
`;
export const LoginButtonNew = styled(LoginButton)`
& span{
    letter-spacing: unset;
    width: 78%;
}
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation:portrait) {
    width: 93%;
}
`
export const NewsButton = styled(Button)`
width: auto;
min-width:20%;
max-width:95%;
// height: 40px;
color: #fff;
margin:auto;
margin-bottom: 13px;
background: #F66700;
padding:10px;
box-shadow: 0px 3px 0px #C75300;
// position: relative;
// left: 40%;
`
export const ContinueButton = styled(Button)`
background: #F66700;
box-shadow: 0px 3px 0px #C75300;
width: 90%;
margin-top: 13px;
& span{
    font-style: normal;
    font-size: 18px;
    line-height: 120%;
    display: inline-flex;
    align-self:center;
    letter-spacing: 0.01em;
    color: #FFFFFF;
    position:relative;
}
& span:after{
    background: url(${nextLogo}) 0 0;
    content:" ";
    width:16px;
    height:16px;
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    right:-25px;
}

@media screen and (max-width: 850px){
    &{
        margin-left:auto;
        margin-top: 18px;
        // width: 350px;  //removed for mobile screens
        display: block;
    margin-right: auto;
    }
} 
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation:portrait) {
    width: 93%;
}
@media screen and (max-width: 480px){
    &{
        margin-left:auto;
        margin-top: 36px;
        // width: 350px;  //removed for mobile screens
    }
} 
`;

export const LetsExplore = styled(LoginButton)`
    position:absolute;
    bottom:6vh;
    width: auto;
    height:auto;
    padding:1.5vh 9vh 1.8vh 4.5vh;
`

export const GuestButton = styled(Button)`
  background: #00ACCA;
  box-shadow: 0px 3px 0px #015F70;
  margin-top: 13px;
  width: 304px;
  & span {
    width: 85%;
    font-family: 'Lato-Bold';
    font-size: 18px;
    line-height: 120%;
    display: flex;
    justify-content: center;   
    align-items: center;      
    letter-spacing: unset;
    color: #FFFFFF;
    position: relative;
    margin-left: 10px;
  }
  & span:after {
    background: url(${guestLogo}) no-repeat center;
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -20px;   
  }
@media screen and (max-width: 850px){
    &{
        margin-left:auto;
        margin-top: 10px;   
        //width: 350px; //removed for mobile screen
    }
}
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation:portrait) {
    width: 93%;
}
`;

export const HelpButton = styled.button`
background: #00000080;
border-radius: 5px;
max-width: 200px;
height: 43px;
padding:10px;
& span:before{
    background: url(${helpLogo}) 0 0;
    content:"  ";
    width: 20.34px;
    height: 21px;
    position:absolute;
    left:11px;
    top:11px;
}
& span{
    font-family: 'Lato';
    font-style: normal;
    font-size: 14px;
    line-height: 120%;
    color: #FFFFFF;
    flex: none;
    order: 1;
    display: inline-flex;
    align-self:center;
    letter-spacing: 0.01em;
    flex-grow: 0;
    padding-left:25px;
}
}`;

export const LanguageSelectionButton = styled(Button)`
width: 326px;
height: 45px;
background:#000000;
border-bottom: 1px solid rgba(255, 255, 255, 0.7);
border-radius: 6px;
position:relative;
color:#ffffff;
margin-bottom:10px;
text-align:left;
padding:10px;
img{
    padding-right: 10px;
}

& span{
    font-style: normal;
    font-size: 18px;
    line-height: 120%;
    display: inline-flex;
    align-self:center;
    letter-spacing: 0.01em;
    color: #FFFFFF;
}
& :after{
    content:""
    position: absolute;
    right: 1%;
    top: 25%;
    color: #ffffff;
}
`;

export const IncreaseImpactButton = styled.button`
// position: relative;
display: flex;
width: 96%;
height: auto;
max-height:8vh;
padding: 13px 15px;
justify-content: center;
align-items: center;
gap: 12px;
// top:-2.7vh;
// left:0.5vh;
flex-shrink: 0;
border-radius: 8px;
border: 1px solid #FF6B00;
background: #F66700;
box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
margin: 0 2% 2% 2%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin: 4% 2% 2% 2%;
    }

& span:before{
    background: url(${anotherChildicon}) 0 0;
    content:"  ";
    // background-size: contain;
    width: 28px;
    height: 19px;
    margin-right: 5px;
    //position:absolute;
    //left:0%;
    ////top:50%;
    //transform: translate(-100%,-50%);
    background-repeat: no-repeat;

    @media screen and (max-width: 850px){
        left:-10.5%
        transform: translate(-0%,-50%);
    }
}
& span{
   // padding-left: 5px;
    position:relative;
    //left:0.6vw;
    color: #FFF;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    display: flex;
    justify-content: center;
    align-items: center;
    //flex-direction: column;
    //flex-shrink: 0;
    width: fit-content;
}
}`;

export const VisitWebSiteImpactButton = styled.button`
// position: relative;
display: flex;
width: 96%;
height: auto;
max-height:8vh;
padding: 13px 15px;
justify-content: center;
align-items: center;
gap: 12px;
// top:-2.7vh;
// left:0.5vh;
flex-shrink: 0;
border-radius: 8px;
border: 1px solid #FF6B00;
background: #F66700;
box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
margin: 0 2% 2% 2%;
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
{
    margin: 4% 2% 2% 2%;
}
& span:before{
    background: url(${visitWebSiteicon}) 0 0;
    content:"  ";
    background-size: contain;
    width: 28px;
    height: 19px;
    margin-right: 5px;
    //position:absolute;
    //left:0%;
    ////top:50%;
    //transform: translate(-100%,-50%);
    background-repeat: no-repeat;

    @media screen and (max-width: 850px){
        left:-10.5%
        transform: translate(-0%,-50%);
    }
}
& span{
   // padding-left: 5px;
    position:relative;
    //left:0.6vw;
    color: #FFF;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    display: flex;
    justify-content: center;
    align-items: center;
    //flex-direction: column;
    //flex-shrink: 0;
    width: fit-content;
}
}`;

export const ReferFriendButton = styled(IncreaseImpactButton)`
& span:before{
    background: url(${referIcon}) 0 0;
    width: 21px;
    height: 19px;
    margin-right: 5px;
}`;

export const RecivedMsgButton = styled.button`
position: relative;
display: flex;
width: 75px;
height: 30px;
padding: 13px 16px 13px 19px;
justify-content: center;
align-items: center;
top: 1vh;
left:1.5vw;
flex-shrink: 0;
border-radius: 8px;
border: 1px solid #FF6B00;
background: #F66700;
box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
& span{
    position:relative;
    padding-right: 15%;
    color: #FFF;
    font-family: Lato;
    font-size: 13px;
    font-style: normal;
    line-height: 120%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}
}`;
